export default __webpack_public_path__ + "static/media/LoginPic.286a10f9.svg";